import styled from 'styled-components';

export const LinkButton = styled.button`
  border: none;
  background-color: initial;
  color: inherit;
  font-size: 1rem;
  text-decoration: underline;

  &:hover {
    color: ${Styles.color.tertiary};
    cursor: pointer;
  }
`;
